module.exports = __webpack_public_path__ + "static/img/campo_indicaciones.dc9ea2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/campo_indicaciones.png
// module id = 1629
// module chunks = 6